// extracted by mini-css-extract-plugin
export default {"page":"page_page__nWSvT","pageContent":"page_pageContent__j2ux0","mainContent":"page_mainContent__3+fSQ"};